export default __webpack_public_path__ + "static/media/boy.347eb4bd.jpg";